// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__3T_Sf","bold":"styles_bold__2Yyt-"};